const Builder = require('../BuilderBase');
const HiddenFor = require('../HiddenFor');

module.exports = class Toggle extends Builder {
    constructor(title, properties) {
        super('formElement_Toggle', title, properties);
    }
    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }
};
